import { HandlerBody, handler, parseJson, parseMsDate, getCallFolderName } from "."
import * as model from '../model';


function callHistoryHandlerRaw(body: HandlerBody, ucStatus = true) {
  return handler('/Handlers/CallHistoryHandler.ashx', body, ucStatus)
}

async function callHistoryHandler<T = any>(body: HandlerBody, ucStatus = true) {
  return parseJson<T>(await callHistoryHandlerRaw(body, ucStatus))
}

export function clearCallFolder(folder: model.CallFolder) {
  return callHistoryHandlerRaw({ command: 'clearcallhistory', value: getCallFolderName(folder) })
}

export function markCallFolderAsRead(folder: model.CallFolder) {
  return callHistoryHandlerRaw({ command: 'markasread', value: getCallFolderName(folder) })
}

interface CallHistoryEntry {
  id: string
  clid: string
  clidDescription: string
  subject: string
  dateTimeStartUtc: string
}

export async function getCallHistory(number: string, description: string) {
  return (await parseJson<CallHistoryEntry[]>(await callHistoryHandlerRaw({ command: 'current', value: number, data: description }))).map<model.CallHistoryEntry>(row => ({
    id: row.id,
    clid: row.clid,
    clidDescription: row.clidDescription,
    date: parseMsDate(row.dateTimeStartUtc) || 0,
    subject: row.subject,
  }))
}

export async function getCallHistoryDetails(id: string, mediaTypeId: model.MediaType, itemAction: model.TaskItemAction) {
  if (mediaTypeId === 'EMAIL') {
    return await callHistoryHandler<model.CallHistoryDetailsEntry>({ command: 'history-email', value: id, data: itemAction.toString() })
  } else if (mediaTypeId === 'TC') {
    return await callHistoryHandler<model.CallHistoryDetailsEntry>({ command: 'history-chat', value: id, data: itemAction.toString() })
  } else if (mediaTypeId === 'CALL' || mediaTypeId === 'VM') {
    return await callHistoryHandler<model.CallHistoryDetailsEntry>({ command: 'history-call', value: id, data: itemAction.toString() })
  } else if (mediaTypeId === 'TWEET') {
    return await callHistoryHandler<model.CallHistoryDetailsEntry>({ command: 'history-tweet', value: id, data: itemAction.toString() })
  } else if (mediaTypeId === 'FB') {
    return await callHistoryHandler<model.CallHistoryDetailsEntry>({ command: 'history-fb', value: id, data: itemAction.toString() })
  }  else if (mediaTypeId === 'OUT') {
    return await callHistoryHandler<model.CallHistoryDetailsEntry>({ command: 'history-out', value: id, data: itemAction.toString() })
  }
}
